<div class="quickbet-info-spot">
    <p class="qb-stake-info" data-crlat="totalStake">
        <span [i18n]="'quickbet.stakeLabel'" data-crlat="label"></span>
        @if (!selection.freebetValue) {
            <span [textContent]="getTotalStake()" data-crlat="value"></span>
        } @else {
            <span class="freebet-stake" data-crlat="combinedStake">
                <span class="free-bet-label">
                    <free-bet-label
                        [freeBetLabelText]="selection.freeBetOfferCategory"
                        [selected]="selection.freebetValue"
                        [jump]="'jump'"
                        [plusSuffix]="selection.stakeAmount >= 0">
                    </free-bet-label>
                </span>
                @if (selection.stakeAmount >= 0) {
                    <span [textContent]="getStake()"></span>
                }
            </span>
        }
    </p>
    <p class="qb-return-info">
        @if (isLuckyDip) {
            <span [i18n]="'quickbet.potentialReturns'" data-crlat="estReturnsLabel"></span>
        } @else {
            <span [i18n]="'quickbet.estReturns'" data-crlat="estReturnsLabel"></span>
        }
        <span [textContent]="isCapped()" data-crlat="totalEstReturns"></span>
    </p>
</div>
